<template>
  <div>
    <b-button v-b-modal.modal-fechamento-caixa
              class="w-100 mt-5 mb-3"
              variant="danger"
              size="lg">
      Fechar caixa
    </b-button>
    <b-modal id="modal-fechamento-caixa"
             centered
             title="Fechamento de caixa"
             header-bg-variant="secondary"
             header-text-variant="white">
      <div class="d-flex flex-column">
        <span>Gostaria de finalizar esse caixa?</span>
        <span><strong>Saldo total: </strong>{{ cxSaldo.pedidos.saldoTotal | moneyToString }}</span>
      </div>
      <template #modal-footer="{close}">
        <b-button variant="secondary"
                  class="mr-3 pl-4 pr-4 btn-voltar"
                  @click="close()">
          Voltar
        </b-button>
        <b-button variant="primary"
                  class="mr-3 pl-4 pr-4"
                  @click="fecharCaixa">
          Sim
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  //Services
  import caixaService from '../caixaService'

  export default {
    name: "ModalFechamentoCaixa",
    data () {
      return {

      }
    },
    computed: {
      caixaStore () {
        return this.$store.state.frenteCaixa.caixa
      },
      cxSaldo () {
        return this.$store.state.frenteCaixa.saldo
      },
      cxData () {
        return this.$store.state.frenteCaixa.cxData
      }
    },
    methods: {
      async fecharCaixa () {
        loader({active: true})
        try {
          loader({text: 'Fechando caixa', active: true})          
          const payload = {
            caixa: this.caixaStore,
            // retira o saldo anterior, para salvar apenas o saldo final do caixa atual
            saldoFinal: this.cxSaldo.pedidos.saldoTotal - this.cxSaldo.pedidos.saldoAnterior
          }
          const caixa = await caixaService.fecharCaixa(payload)
          this.$store.dispatch('frenteCaixa/atualizarCaixa', caixa)
          displayMessage('success', 'success', 'Caixa fechado com sucesso, vá ao final da página caso deseje imprimir um relário')
        } catch (error) {
          const { message } = getErrors(error)
          displayMessage('error', 'Erro', message)
        } finally {
          loader({active: false})
        }

      }
    },
  }
</script>